import { Skeleton } from 'components/Skeleton/Skeleton'
import styles from './XPhotoBox.module.scss'
import cx from 'classnames'
import { MediaObject } from 'types'
import { MediaRenderer } from '../components/MediaRenderer/MediaRenderer'
import { BlankMediaPlaceholder } from '../components/MediaRenderer/BlankMediaPlaceholder'
import { DesignChannel } from 'components/NewFileModal/Types'

interface Props {
  mediaObjects?: MediaObject[]
  loading?: boolean
  imagesLoading?: boolean
  showVideoControls?: boolean
  isActive?: boolean
  isInsertingMedia?: boolean
  isPressable?: boolean
  isGenerating?: boolean
  showHoverActionOverlay?: boolean
  almanacFileKey?: string
  onClose?: () => void
  content?: string
}

export const XPhotoBox = ({
  mediaObjects,
  loading = false,
  imagesLoading,
  showVideoControls,
  isActive = true,
  isInsertingMedia = false,
  isPressable = true,
  showHoverActionOverlay = false,
  isGenerating = false,
  almanacFileKey,
  onClose,
  content,
}: Props) => {
  const isOneImage = mediaObjects?.length === 1

  const getImageLayoutClass = (totalImages: number) => {
    switch (totalImages) {
      case 2:
        return styles.twoImages
      case 3:
        return styles.threeImages
      case 4:
        return styles.fourImages
      default:
        return styles.oneImage
    }
  }

  if (imagesLoading || isInsertingMedia) {
    return (
      <div className={cx(styles.photoBox, { [styles.isOneImage]: isOneImage })}>
        {[...Array(2).keys()].map((imageLoader) => (
          <Skeleton key={imageLoader} className={getImageLayoutClass(2)} active paragraph={{ rows: 1 }} title={false} />
        ))}
      </div>
    )
  }

  if (!loading && mediaObjects?.length === 0) {
    return (
      <BlankMediaPlaceholder
        channel={DesignChannel.TwitterPost}
        showHoverActionOverlay={showHoverActionOverlay}
        almanacFileKey={almanacFileKey}
        caption={content}
        onClose={onClose}
        aspectRatio={16 / 9}
      />
    )
  }

  if (!mediaObjects?.length) return null

  return (
    <div className={cx(styles.photoBox, { [styles.isOneImage]: isOneImage })}>
      {mediaObjects.map((mediaObject) => {
        return (
          <div key={mediaObject.id} className={cx(styles.imageContainer, getImageLayoutClass(mediaObjects.length))}>
            <MediaRenderer
              channel={DesignChannel.TwitterPost}
              mediaObject={mediaObject}
              alt={'twitter'}
              showVideoControls={showVideoControls}
              isActive={isActive}
              isPressable={isPressable}
              showHoverActionOverlay={showHoverActionOverlay}
              almanacFileKey={almanacFileKey}
              onClose={onClose}
              isGenerating={isGenerating}
              allMediaObjects={mediaObjects}
            />
          </div>
        )
      })}
    </div>
  )
}
